import React from 'react';
import { useTranslator } from '@eo-locale/react';
import { styled } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { classes } from '@guest-widgets/shared/src/classes';
import { WithClassName } from '@guest-widgets/shared/src/types/withClassName';
import { usePopupState, bindToggle, bindPopper } from 'material-ui-popup-state/hooks';

import { CheckboxList } from '../CheckboxList';
import { useFormatFilterValue } from '../../../useFormatFilterValue';
import { useFilters } from '../../../filtersContext/filtersContext';
import { useFilterAttributes } from '../../../filterAttributesContext';

import { Popper } from './Popper';
import { FilterTextField } from './FilterTextField';

export const Categories = ({ className }: WithClassName) => {
  const translator = useTranslator();
  const {
    filters: { categories },
    setCategories,
  } = useFilters();
  const { attributes, isSuccess } = useFilterAttributes();
  const { categories: formatValue } = useFormatFilterValue();
  const popupState = usePopupState({ variant: 'popper', popupId: 'category-filters' });

  if (!attributes?.categoryOptions?.length) {
    return null;
  }

  return (
    <>
      <StyledTextField
        popupState={popupState}
        className={`${classes.catalog.filters.categories.input} ${className || ''}`}
        value={formatValue(categories)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <ArrowDropDownIcon />
            </InputAdornment>
          ),
        }}
        placeholder={translator.translate('product-catalog.filters.categories.placeholder')}
        label={translator.translate('product-catalog.filters.categories.title')}
        {...bindToggle(popupState)}
      />

      {isSuccess && (
        <Popper
          className={classes.catalog.filters.categories.root}
          popperTitle="product-catalog.filters.categories.title"
          placement="bottom-start"
          popupState={popupState}
          {...bindPopper(popupState)}
        >
          <CheckboxList
            onSelect={setCategories}
            filterValues={categories}
            attributeOptions={attributes?.categoryOptions}
          />
        </Popper>
      )}
    </>
  );
};

const StyledTextField = styled(FilterTextField)({
  // this is for the german multi selection to fit
  width: '240px',
});
